import _reactJsxRuntimeProductionMin from "./cjs/react-jsx-runtime.production.min.js";
export { _reactJsxRuntimeProductionMin as default };
export const Fragment = _reactJsxRuntimeProductionMin.Fragment,
  jsx = _reactJsxRuntimeProductionMin.jsx,
  jsxs = _reactJsxRuntimeProductionMin.jsxs;